import $ from 'jquery';
import Slider, {
  cssClassSwiperWrapper,
} from '../../js/modules/Slider.mjs';
import {
  gridBreakpoints,
  gridGutterWidth,
} from '../../js/utilities/media-queries.mjs';

const $sliders = $('.js_ef-collection-card-slider');

$sliders.each((index, slider) => {
  const $slider = $(slider);
  const $sliderWrapper = $slider.find(`.${cssClassSwiperWrapper}`);
  const SliderCollectionCard = new Slider({
    namespace: 'CollectionCard',
    sliderNode: slider,
    swiperConfigOverride: {
      breakpoints: {
        [gridBreakpoints.xs]: {
          slidesPerView: 1,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.md]: {
          slidesPerView: 2,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.lg]: {
          slidesPerView: 3,
          spaceBetween: gridGutterWidth
        }
      }
    },
    callbacks: {
      onInitStart() {
        $sliderWrapper.addClass('no-gutters');
      },
      onDestroy() {
        $sliderWrapper.removeClass('no-gutters');
      },
    },
  });

  if (SliderCollectionCard.slidesDontFitIntoWrapper()) {
    SliderCollectionCard.init();
  }
  SliderCollectionCard.attachResize();
});
